import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "3",
      height: "12",
      x: "2",
      y: "12",
      fill: "currentColor",
      rx: "1.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "3",
      height: "18",
      x: "11",
      y: "6",
      fill: "currentColor",
      rx: "1.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "3",
      height: "24",
      x: "20",
      fill: "currentColor",
      rx: "1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }